import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './icon.png'


const _withScopeId = n => (_pushScopeId("data-v-62a7cd7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flx bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fl" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "s80",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "h4",
      id: "font-size"
    }, "Team Roxe"),
    /*#__PURE__*/_createElementVNode("div", { id: "font-size" }, "June 27, 2022")
  ])
], -1))
const _hoisted_3 = { class: "fl fl1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "font-size" }, "5 Minutes Read", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Share = _resolveComponent("Share")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Share)
    ])
  ]))
}